<template>
  <div class="outer-wrapper">
    <div class="title">
      <p>自由出具报告</p>
    </div>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>报告类别：</td>
              <td>
                <select v-model="item.category" style="width:200px;height:30px;">
                  <option :value="c.value" v-for="(c,index) in categoryList" :key="index">{{c.name}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>编号：～</td>
              <td>
                <input type="text" placeholder v-model="item.pronumRange" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>报告日期：</td>
              <td>
                <input type="date" placeholder v-model="item.reportDate" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>备注：</td>
              <td>
                <input type="text" placeholder v-model="item.remark" style="width:200px;" />
              </td>
            </tr>
          </table>
        </div>
        <div style="text-align:center;margin-top:20px;width:600px;">
        <Button style="margin-right:15px;" @click="doReport()">提交</Button>
        <Button  @click="closeModal('confirm')">取消</Button>
      </div>
      </div>
      
  </div>
</template>
<script>
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");
//import shellExpand from "./ShellExpand.vue";

function itemValue() {
  return {
    pronumRange: "",
    reportDate: null,
    category:"",
    remark: ""
  };
}

export default {
  name: "freeReport",
  props: [],
  components: {
  },
  data() {
    return {
      op_name: this.$options.name,
      categoryList:[{name:'渗透报告',value:'pt'},{name:'磁粉报告',value:'mt'},],
      update_count: 0,
      modalValue: {
        confirm: false
      },
      item: itemValue(),
    };
  },
  computed: {},
  methods: {
    linkTo(url) {
      window.open(this.$fileUrlFac(url, authData.sfileRight));
    },
    openModal(value) {
      this.modalValue[value] = true;
    },
    closeModal(value) {
      this.modalValue[value] = false;
    },
    doReport() {
      this.$axios
        .post(this.$url + "/report", {
          userToken: userToken,
          askData: this.item.category+"Create",
          item: this.item
        })
        .then(response => {
          if (response.data.stat == "ok") {
            window.open('/archive/'+this.item.category+'Report/'+response.data.fid,"_blank");
            this.closeModal("confirm");
            this.update_count++;
          } else {
            this.closeModal("confirm");
            this.$Message.error(response.data.data.info);
          }
        })
        .catch(error => {
          this.$Message.error("网络连接有误！" + error);
        });
    }
  }
};
</script>
<style scoped>
.outer-wrapper {
  width: 1280px;
  margin: 0 auto;
  min-height: 800px;
}

.sc-content-wrapper{
  width:600px;
  margin: 150px auto;
}
.title {
  text-align: center;
  margin: 10px auto;
  font-size: 20px;
}
.cr-form {
  width: 100%;
  border-collapse: collapse;
}

.cr-form td {
  height: 45px;
}

.cr-form td:first-child {
  text-align: right;
}

.cr-form input {
  padding: 0 10px;
  outline: none;
  height: 30px;
  border-radius: 2px;
  border: 1px solid #aaa;
}
</style>